import { render, staticRenderFns } from "./DateTooltippedTableCell.vue?vue&type=template&id=0b2077b6&scoped=true&"
import script from "./DateTooltippedTableCell.vue?vue&type=script&lang=ts&"
export * from "./DateTooltippedTableCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2077b6",
  null
  
)

export default component.exports